import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import { Textarea } from "../../../Input/Textarea";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import {
  DeleteModalCommonProps,
  DeleteModalLabel,
} from "../../Users/UserDetail/CommentModal/CommentDeleteModal";

interface MatchingCancelModalProps extends DeleteModalCommonProps {
  uid: string;
  servsubsid: number;
}

export default function MatchingCancelModal({
  closeEvent,
  cancelEvent,
  uid,
  servsubsid,
}: MatchingCancelModalProps) {
  const [deleteBtnClick, setDeleteBtnClick] = useState(false);
  const [reason, setReason] = useState("");

  // 코멘트 삭제
  const { response } = useApi({
    method: "post",
    url: deleteBtnClick ? `party/request` : undefined,
    data: {
      uid,
      servsubsid,
      reason,
    },
  });

  console.log(response);

  useEffect(() => {
    if (response?.status === 200) {
      if (cancelEvent) {
        cancelEvent();
      }
      toast.success("매칭이 취소되었습니다.", {});
    }
  }, [cancelEvent, response]);

  return (
    <DefaultModalLayout
      modalTitle="매칭 취소"
      isDeleteModal={true}
      isSmallModal={true}
      closeEvent={() => cancelEvent()}
      confirmEvent={() => setDeleteBtnClick(true)}
      type="input"
      confirmDisabled={reason === ""}
    >
      <DeleteModalLabel>취소 사유</DeleteModalLabel>

      <Textarea
        placeholder="삭제 사유 입력(100글자 이내)"
        onChange={(e) => setReason(e.target.value)}
        value={reason}
      />
    </DefaultModalLayout>
  );
}
